import { render, staticRenderFns } from "./DependentPage.vue?vue&type=template&id=0f2d12af&scoped=true"
import script from "./DependentPage.vue?vue&type=script&lang=js"
export * from "./DependentPage.vue?vue&type=script&lang=js"
import style0 from "./DependentPage.vue?vue&type=style&index=0&id=0f2d12af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d12af",
  null
  
)

export default component.exports